import Input from "@/v2-ui/input"
import TenantPicker from "@/v2-backoffice-client/tenant/TenantPicker"
import UserTenantTypePicker from "@/v2-backoffice-client/user/tenant/type/UserTenantTypePicker"
import ContactEmailStatusDot from "@/v2-backoffice-client/crm/ContactEmailStatusDot"
import type { ContactEmailChecks } from "@/v2-backoffice-client/crm/crm.contactChecks.hooks"
import type { UserCreateRow } from "@/v2-backoffice-client/user/create/many/UserCreateManyForm"
import BulkForm, {
  type BulkFormProps,
} from "@/v2-backoffice-client/components/bulkForm"

export type UserCreateManyTableProps = BulkFormProps<UserCreateRow> & {
  /** The live email check every row reads its HubSpot dot from. */
  checks: ContactEmailChecks
  createContact: boolean
}

function UserCreateManyTable(props: UserCreateManyTableProps) {
  const { rows, onUpdateRow, onRemoveRow, checks, createContact } = props

  return (
    <BulkForm.Table>
      <thead>
        <tr>
          <th>Email *</th>
          <th>First Name *</th>
          <th>Last Name *</th>
          <th>Team</th>
          <th>Role</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={row.key}>
            <td data-label="Email" data-full-width className="relative">
              <Input
                type="email"
                className="pr-7"
                required
                placeholder="user@example.com"
                value={row.Email}
                onChange={(e) => {
                  onUpdateRow(index, "Email", e.target.value)
                }}
              />
              <ContactEmailStatusDot
                email={row.Email}
                checks={checks}
                createContact={createContact}
              />
            </td>
            <td data-label="First Name">
              <Input
                type="text"
                required
                placeholder="First name"
                value={row.FirstName}
                onChange={(e) => {
                  onUpdateRow(index, "FirstName", e.target.value)
                }}
              />
            </td>
            <td data-label="Last Name">
              <Input
                type="text"
                required
                placeholder="Last name"
                value={row.LastName}
                onChange={(e) => {
                  onUpdateRow(index, "LastName", e.target.value)
                }}
              />
            </td>
            <td data-label="Team">
              <TenantPicker
                className="w-full"
                align="between"
                variant="outline"
                size="md"
                iconSrc="angle-small-down"
                iconPosition="right"
                iconClassName="text-muted-foreground"
                onSelect={(tenant) => {
                  onUpdateRow(index, "TenantId", tenant.Id)
                  onUpdateRow(index, "TenantName", tenant.Name)
                }}
              >
                {row.TenantName ?? "Select team..."}
              </TenantPicker>
            </td>
            <td data-label="Role">
              {row.TenantId === undefined ? (
                <span className="text-sm text-muted-foreground px-3">—</span>
              ) : (
                <UserTenantTypePicker
                  className="w-full"
                  align="between"
                  variant="outline"
                  size="md"
                  iconSrc="angle-small-down"
                  iconPosition="right"
                  iconClassName="text-muted-foreground"
                  value={row.UserTenantTypeCode}
                  onChange={(code) => {
                    onUpdateRow(index, "UserTenantTypeCode", code)
                  }}
                />
              )}
            </td>
            <BulkForm.RemoveCell
              onRemove={() => {
                onRemoveRow(index)
              }}
            />
          </tr>
        ))}
      </tbody>
    </BulkForm.Table>
  )
}

export default UserCreateManyTable
